import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import DownloadGuide from './components/DownloadGuide';
import GameStats from './components/GameStats';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTABanner from './components/CTABanner';

export default function Home() {
  return (
    <>
      <SEOHead
        title="征途国际App下载安装最新版-官方正版免费获取 | 征途国际手游官方下载"
        description="征途国际App最新版官方下载安装，支持Android与iOS双平台，安全无病毒，一键安装即玩。经典征途国际手游焕新升级，海量玩法等你体验，立即下载征途国际最新版App！"
        keywords="征途国际app下载,征途国际最新版,征途国际安装,征途国际手游下载,征途国际官方下载,征途国际apk下载,征途国际ios下载"
        canonicalUrl="https://hspew.cn"
      />
      <HeroSection />
      <FeaturesSection />
      <DownloadGuide />
      <GameStats />
      <LatestArticles />
      <FAQSection />
      <CTABanner />
    </>
  );
}